import { capitalize } from '@material-ui/core';

import { DecisionRecordData } from '@spotify/confidence-graphql';

export const getDecisionLabel = (
  decision?: Pick<DecisionRecordData, 'outcome'> | null,
): string => capitalize(decision?.outcome?.toString() ?? 'Finished');
